export const projects = [
  {
    id: 1,
    img: "./images/steadfast.gif",
    title: "Steadfast Communications",
    about: `Steadfast Communications is the sister concern of Steadfast International Services, LLC. Which is the leading talent acquisition platform that delivers top candidates to enterprises by leveraging the largest community of recruiters and sourcing technology platforms.`,
    tools: [
      "JavaScipt",
      "React",
      "Redux",
      "Redux toolkit",
      "Redux Persist",
      "React-Query",
      "React-Router",
      "Styled-Component",
      "Express.js",
      "Node.js",
      "MongoDB",
      "React-Bootstrap",
    ],
    live: "https://steadfastbd.netlify.app/",
    client: "https://github.com/sm-mostafajamal/steadfast-frontend/tree/main",
    server: "https://github.com/sm-mostafajamal/steadfast-backend",
  },
  {
    id: 2,
    img: "./images/admin.gif",
    title: "Steadfast Admin Panel",
    about: `This is Steadfast Communications Admin panel where admin can create, delete, update or check the jobs. Also they can receive the applied job data which is submitted by candidate. The Admin panel supports Dark mode`,
    tools: [
      "React",
      "Redux",
      "Redux toolkit",
      "Redux Persist",
      "React-Query",
      "React-Router",
      "Styled-Component",
      "Express.js",
      "Node.js",
      "MongoDB",
      "React-Bootstrap",
      "JWT Authrization",
    ],
    // live: "https://steadfastbd.netlify.app/",
    client: "https://github.com/sm-mostafajamal/Steadfast-Admin-Panel",
    server: "https://github.com/sm-mostafajamal/steadfast-backend",
  },
  {
    id: 3,
    img: "./images/storyBlog.gif",
    title: "Story-Blog",
    about: `A Full Stack web app where use can login with google oauth and they can create thier story or blog. User also can change the blog status to private or public.`,
    tools: [
      "JavaScript",
      "EJs",
      "HTML",
      "CSS",
      "Express.js",
      "Node.js",
      "MongoDB",
    ],
    live: "https://story-blog.onrender.com/",
    client: "https://github.com/sm-mostafajamal/Story-Blog",
    server: "https://github.com/sm-mostafajamal/Story-Blog",
  },
  {
    id: 4,
    img: "./images/ecommerce.png",
    title: "Ecommerce",
    about: `Built with MERN stack a responsive website where user has to register or log in so that they can purchase items. Admin can check the users product that they want to purchase also they can check the profile in dashboard.`,
    tools: [
      "React",
      // "Redux",
      // "Redux toolkit",
      // "Redux Persist",
      // "React-Query",
      "React-Router",
      "Styled-Component",
      // "Express.js",
      // "Node.js",
      // "MongoDB",
      "React-Material-ui",
    ],
    live: "https://ecommerce-d.netlify.app/",
    client: "https://github.com/sm-mostafajamal/Ecommerce",
    server: "https://github.com/sm-mostafajamal/Ecommerce",
  },
];
